module.exports = __webpack_public_path__ + "img/telemidia_light.23fad814.png";